export const titulos = {
      antetitulo: 'Cádiz 1936',
      titulo: 'IMAGEN DE UNA TRAGEDIA',
      subtitulo: 'La Biblioteca Nacional de España publica una serie de fotografías, la gran parte inéditas, sobre los primeros días de la Guerra Civil en Cádiz. El prestigioso fotógrafo Dubois fue el autor de la mayor parte de las imágenes',
      texto: 'J.A. Hidalgo'
};



// WEBPACK FOOTER //
// ./src/data/titulos.js